import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { FundingApplicationSchemas } from "api-types";
import { useAxios } from "auth-sdk";

import { FUNDING_APPLICATION_CONNECTIONS_PREVIEW_API } from "../../components/constants";

export const CONNECTIONS_PREVIEW_QUERY_KEY = ["connectionsPreview"] as const;

export const useConnectionsPreview = (
  customerDomain: string,
  request: FundingApplicationSchemas.ConnectionsPreviewRequest
) => {
  const client = useAxios();
  const url = FUNDING_APPLICATION_CONNECTIONS_PREVIEW_API.replace(":customerSlug", customerDomain);

  return useQuery({
    queryKey: [
      ...CONNECTIONS_PREVIEW_QUERY_KEY,
      customerDomain,
      request.customerSegments,
      request.salesChannels,
      request.productOfferings,
    ],
    queryFn: async () => {
      const { data } = await client.post<FundingApplicationSchemas.ConnectionsPreviewResponse>(url, request);
      return data;
    },
    placeholderData: keepPreviousData,
    staleTime: 30000,
  });
};
